import { render, staticRenderFns } from "./TemplateNews.vue?vue&type=template&id=2e6b82cd&scoped=true"
import script from "./TemplateNews.vue?vue&type=script&lang=js"
export * from "./TemplateNews.vue?vue&type=script&lang=js"
import style0 from "./TemplateNews.vue?vue&type=style&index=0&id=2e6b82cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b82cd",
  null
  
)

export default component.exports